var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplicitTemperatureFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#DD1155"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0375 13.4297L11.107 10.5008L14.0375 7.59351C14.1843 7.42341 14.1764 7.16816 14.0192 7.00767C13.862 6.84717 13.6087 6.83555 13.4376 6.98099L10.4986 9.86673L7.61096 6.95942C7.44385 6.79217 7.17397 6.79217 7.00687 6.95942C6.92576 7.04041 6.88014 7.15066 6.88014 7.26568C6.88014 7.38069 6.92576 7.49094 7.00687 7.57194L9.89022 10.4749L6.95974 13.3779C6.87863 13.4589 6.83301 13.5692 6.83301 13.6842C6.83301 13.7992 6.87863 13.9095 6.95974 13.9905C7.04059 14.0712 7.15005 14.1162 7.26393 14.1155C7.37572 14.1162 7.48334 14.0729 7.56383 13.9948L10.4986 11.0831L13.4376 14.0422C13.5185 14.123 13.628 14.168 13.7418 14.1673C13.8542 14.1668 13.9619 14.1219 14.0417 14.0422C14.1223 13.9607 14.1671 13.8501 14.1663 13.7351C14.1655 13.62 14.1191 13.5101 14.0375 13.4297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplicitTemperatureFail);
export default __webpack_public_path__ + "static/media/implicit_temperature_fail.559092e0a90828fbc7587747a1cdd0ce.svg";
export { ForwardRef as ReactComponent };